export default __webpack_public_path__ + "static/media/outlinedEdit.e026875d.svg";